import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { OldPwdValidators } from './old-pwd.validators';

import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { GlobalService } from 'src/app/shared/services/global_variable.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss', '../../../assets/css/psycho-style.css']
})
export class HeaderComponent implements OnInit {

    constructor(private translate: TranslateService, public router: Router, private fb: FormBuilder,
        public route: ActivatedRoute, private location: Location,
        private _http: HttpClient, private _globalService: GlobalService, private messageService: MessageService, private TranslateService: TranslateService) {

        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });

        location.onUrlChange(url => {
            this.pathname = url;
        });

        this.form1 = fb.group({
            'newPwd': ['', Validators.required],
            'currentPwd': ['', Validators.required]
        });

        this.ObjSession = JSON.parse(localStorage.getItem('Session'));
        if (this.ObjSession !== undefined && this.ObjSession != null) {
            this.UserTypeID = this.ObjSession.UserTypeID;
            this.UserID = this.ObjSession.UserID;
            this.LoginUserID = this.ObjSession.LoginUserID;
            this.DisplayUserName = this.ObjSession.DisplayUserName;

        }
    }

    public pushRightClass: string;
    form1: FormGroup;
    ObjSession: any;
    UserTypeID: number;
    LoginUserID: number;
    UserID: number;
    DisplayUserName = '';
    clientDetails: any;
    display: boolean;
    pathname: any;
    languageID: string;

    ngOnInit() {
        this.pushRightClass = 'push-right';
        if (localStorage.getItem('SelectedLng') == null) {
            localStorage.setItem('SelectedLng', 'en');
        }
        this.languageID = localStorage.getItem('SelectedLng').toString();
    }
    languageChange(event) {
        this.languageID = event.target.value;
        localStorage.setItem('SelectedLng', event.target.value);
        this.TranslateService.use('login.' + event.target.value);
        location.reload();
    }
    getClientLogo() {

        if (localStorage.getItem('ClientConfig') == null && this.ObjSession) {
            const url = this._globalService.BaseUrl + 'api/Master/GetClientConfig?argvClientID=' + this.ObjSession.ClientID;
            this._http.get(url).subscribe((resp: any) => {
                if (resp && resp.length > 0) {
                    this.clientDetails = resp[0];

                } else {

                    this.clientDetails = { ClientLogoPath: 'images/dust/logo-airtel.svg' };

                }
                localStorage.setItem('ClientConfig', JSON.stringify(this.clientDetails));
            }, (error) => {
                console.log(error);
            });
        } else {
            this.clientDetails = JSON.parse(localStorage.getItem('ClientConfig'));
            if(this.clientDetails) {
                return this._globalService.BaseUrl + this.clientDetails.ClientLogoPath;
            }
            // return '../../../../assets/images/dust/logo-airtel.svg';
        }
    }
    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    rltAndLtr() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('rtl');
    }

    onLoggedout() {



        const url = this._globalService.BaseUrl
        + 'api/Account/Logout';
        this._http.post(url, 'postData').subscribe((resp) => {
        const test = resp as any[];
        }, (error) => {
        console.log(error);
        });

        localStorage.clear();

    }
    onShowChangePWD() {
        this.display = true;
    }
    onFloatClick() {
       // debugger;
       // alert('help me');
        //   /simulations-details?s=121&l=English
        this.router.navigateByUrl('/simulations-details?b=1&s=' + 605 + '&l=English' );

    }
    onChangePassword() {
        debugger;
        if (this.form1.get('currentPwd').value !== '') {
        if (this.form1.get('newPwd').value !== '') {
            const regex = new RegExp('(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=[^0-9]*[0-9]).{8,}');
            const valid = regex.test(this.form1.get('newPwd').value);
            if (valid) {
                const url = this._globalService.BaseUrl + 'api/Master/ChangePassword?argvNewPwd=' + this.form1.get('newPwd').value
                        + '&argvLoginUserID=' + this.LoginUserID + '&argvOldPwd=' + this.form1.get('currentPwd').value + '';
                this._http.get(url).subscribe(resp => {
                    if (resp === 1) {
                        this.showSuccess('Password has been changed successfully');
                    } else {
                        this.showError('Error occurred while changing password');
                    }
                    this.display = false;
                    this.form1.reset();
                });
            } else {
                this.showError('Your password do not match with the complexity level');
            }
        }
        } else {
            this.showError('Please Enter Current Password.');
        }
    }
    changeLang(language: string) {
        this.translate.use(language);
    }

    showSuccess(msg) {
        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: msg });
    }

    showInfo(msg) {
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: msg });
    }

    showWarn(msg) {
        this.messageService.add({ severity: 'warn', summary: 'Warn Message', detail: msg });
    }

    showError(msg) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: msg });
    }

    openProfileDetails() {
        this.router.navigate(['/updateUserProfile']);
    }

}
